export default "__VITE_ASSET__CfQKVTAL__"